import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  inject,
} from '@angular/core';
import { AuthService, NotificationService } from '@services';

@Directive({
  selector: 'a[appAuthorize]',
})
export class AuthorizeDirective {
  private el = inject(ElementRef);
  private authService = inject(AuthService);
  private notificationService = inject(NotificationService);

  @Input() appAuthorize = false;

  @HostListener('click', ['$event'])
  onClick(event: PointerEvent) {
    if (!this.appAuthorize) {
      return;
    }

    event.preventDefault();

    this.authService.getOneTimeToken().subscribe({
      next: (token) => {
        const url = new URL(this.el.nativeElement.href);
        url.searchParams.set('token', token);

        const link = document.createElement('a');
        link.href = url.toString();
        link.download = this.el.nativeElement.download;
        link.target = this.el.nativeElement.target;

        link.click();
      },
      error: (err) => {
        console.error(err);
        this.notificationService.error(
          'Failed to authorize the download request.',
        );
      }
    });
  }
}
